import api from '@/store/helpers/api';
import removeAccents from '@/helpers/removeAccents';

const initialState = {
  query: '',
  list: [],
  loading: false,
  page: 0,
  lastPage: false,
};

const getters = {};

const actions = {
  get({ commit, state }) {
    if (state.loading) {
      return false;
    }

    commit('LOADSTART');
    commit('RESET');
    return api.get('/debunk')
      .then((resp) => {
        commit('SET', resp);
      })
      .finally(() => {
        commit('LOADEND');
      });
  },
  loadMore({ commit, state }) {
    if (state.loading || state.lastPage) {
      return false;
    }

    commit('LOADSTART');
    commit('NEXTPAGE');

    let url = `/debunk?page=${state.page}`;
    if (state.query) {
      const q = removeAccents(state.query);
      url += `&q=${q}`;
    }

    return api.get(url)
      .then((resp) => {
        if (resp.length > 0) {
          commit('APPEND', resp);
        } else {
          commit('LAST');
        }
      }).finally(() => {
        commit('LOADEND');
      });
  },
  search({ commit, state }, query) {
    if (state.loading) {
      return false;
    }

    commit('LOADSTART');
    commit('RESET');
    commit('SEARCH', query);
    const q = removeAccents(state.query);
    return api.get(`/debunk?q=${q}`)
      .then((resp) => {
        commit('SET', resp);
      }).finally(() => {
        commit('LOADEND');
      });
  },
};

const mutations = {
  LOADSTART(state) {
    state.loading = true;
  },
  LOADEND(state) {
    state.loading = false;
  },
  NEXTPAGE(state) {
    state.page += 1;
  },
  SET(state, list) {
    state.list = list;
  },
  SEARCH(state, query) {
    state.query = query;
  },
  APPEND(state, list) {
    state.list = [
      ...state.list,
      ...list,
    ];
  },
  LAST(state) {
    state.lastPage = true;
  },
  RESET(state) {
    state.query = '';
    state.list = [];
    state.page = 0;
    state.lastPage = false;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
